<template>
  <h2 class="fz-301 mb-4.5" style="color: #ff2e53">
    {{ text }}
  </h2>
</template>

<script>
export default {
  name: "sectionHeader",
  props:['text']
}
</script>

<style scoped>

</style>